import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'customer-tracking-main',
  imports: [FormsModule, RouterOutlet, MatInputModule, MatButton],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent {
  private readonly router = inject(Router);
  protected orderId = '';

  protected navigateToOrder(): void {
    if (this.orderId) {
      this.router.navigate([this.orderId]);
    }
  }
}
